import { render } from "./np-modal.vue?vue&type=template&id=71b4f77f"
import script from "./np-modal.vue?vue&type=script&lang=js"
export * from "./np-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__